<template>
  <loader :is-loading="isLoading" color="primary" :full-page="true">
    <v-flex lg6 md6 sm8 xs12>
      <v-card flat id="user-card">
        <v-card-title id="user-title" class="form-title">{{ $t('pages.user.form.title' + this.mode) }}</v-card-title>
        <v-card-text id="user-form" class="form-content">
          <span class="input-label">{{ $t('pages.user.form.givenName') }}</span>
          <validated-component name="givenName" v-model="user.givenName" :validator="$v.user.givenName">
            <v-text-field
              class="user-field"
              v-model="user.givenName"
              maxlength="255"
              :placeholder="$t('pages.user.form.givenName')"
              prepend-inner-icon="$icons_product_name"
              outlined
              hide-details
              no-filter
            ></v-text-field>
          </validated-component>

          <span class="input-label">{{ $t('pages.user.form.familyName') }}</span>
          <validated-component name="familyName" v-model="user.familyName" :validator="$v.user.familyName">
            <v-text-field
              class="user-field"
              v-model="user.familyName"
              maxlength="255"
              :placeholder="$t('pages.user.form.familyName')"
              prepend-inner-icon="$icons_product_name"
              outlined
              hide-details
              no-filter
            ></v-text-field>
          </validated-component>

          <span class="input-label">{{ $t('pages.user.form.email') }}</span>
           <validated-component name="email" v-model="user.email" :validator="$v.user.email">
            <v-text-field
              class="user-field"
              v-model="user.email"
              :placeholder="$t('pages.user.form.email')"
              prepend-inner-icon="$icons_product_email"
              outlined
              hide-details
              no-filter
            ></v-text-field>
          </validated-component>

          <span class="input-label">{{ $t('pages.user.form.communicationLanguage') }}</span>
          <validated-component
            name="communicationLanguage"
            v-model="user.communicationLanguage"
            :validator="$v.user.communicationLanguage"
          >
            <v-select
              class="user-field"
              prepend-inner-icon="mdi-flag"
              outlined
              hide-details
              no-filter
              :items="availableLanguages"
              item-text="name"
              item-value="id"
              v-model="user.communicationLanguage"
            ></v-select>
          </validated-component>

          <span class="input-label">{{ $t('pages.user.form.roles') }}</span>
          <validated-component name="role" v-model="user.role" :validator="$v.user.role">
            <v-select
              class="user-field"
              v-model="user.role"
              :items="roles"
              :item-text="getRoleFromInput"
              item-value="name"
              :placeholder="$t('pages.user.form.roles')"
              prepend-inner-icon="$icons_product_employee"
              outlined
              hide-details
              no-filter
              append-icon="$icons_system_caret_down"
            ></v-select>
          </validated-component>

          <div role="alert" :if="error">{{error}}</div>
        </v-card-text>
        <v-card-actions style="padding: 0 16px;">
          <v-spacer></v-spacer>
          <medium-button
            :loading="saveLoading"
            :disabled="disableSubmit"
            :onclick="saveUser"
            :text="$t('pages.user.form.save')"
          ></medium-button>
        </v-card-actions>
      </v-card>
    </v-flex>
  </loader>
</template>

<script>
import userValidation from './validationDatas/userValidationData';

export default {
  name: 'user-form',
  props: {
    mode: {
      type: String,
      default: 'Add',
      required: false,
    },
    user: {
      type: Object,
      required: true,
    },
    roles: {
      type: Array,
      required: true,
    },
    saveLoading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      error: null,
      isLoading: false,
      validationData: userValidation,
      search: null,
    };
  },
  validations() {
    return userValidation;
  },
  computed: {
    availableLanguages() {
      return [
        { id: 'en', name: this.$t('languages.en') },
        { id: 'fr', name: this.$t('languages.fr') },
      ];
    },
    disableSubmit() {
      return this.$v.$invalid;
    },
  },
  methods: {
    saveUser() {
      this.$emit('save');
    },
    getRoleFromInput(role) {
      return this.$t(`pages.user.roles.${role.name}`);
    },
  },
};
</script>
<style lang="scss" scoped>
  .form-title {
    margin: 16px;
    padding: 16px 0 8px;
    border-bottom: 3px solid #000000;
  }
  .user-field {
    margin-top: 16px;
  }
  .form-content {
    padding-bottom: 4px;
  }
</style>
